export default __webpack_public_path__ + "6454c8f6d16bf441c74474afbb9e7122.png";